import { SxProps, Theme } from '@mui/material/styles'

const styles = {
  card: {
    width: '100%'
  } as SxProps<Theme>,

  sectionTitle: {
    marginTop: 2,
    marginBottom: 1
  } as SxProps<Theme>,

  divider: {
    marginTop: 3,
    marginBottom: 2
  } as SxProps<Theme>
}

export default styles
